module.exports = __webpack_public_path__ + "static/media/planet_1.e2ebe112.svg";